import { 
    Paper, 
    Table, 
    TableBody, 
    TableCell, 
    TableContainer, 
    TableRow, 
    Typography, 
    Chip,
    Divider,
    Box,
    Grid
  } from "@material-ui/core";
  import { formatDinero } from "../../../utils/formatDinero";
import { useEffect, useState } from "react";
  
const formatFechaHora = (fecha) => {
  try {
    if (!fecha || fecha === '0001-01-01T00:00:00') return 'No especificada';
    const date = new Date(fecha);
    return isNaN(date.getTime()) 
      ? 'Fecha inválida' 
      : date.toLocaleString('es-MX', {
          day: '2-digit',
          month: 'short',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        }).replace(/\./g, '');
  } catch (error) {
    console.error('Error formateando fecha:', error);
    return 'Fecha inválida';
  }
};

const TablaPreciosAPI = ({ listaPrecios, regionActiva, error }) => {

    const [loading, setLoading] = useState(true);

    useEffect(() => {
      if (listaPrecios) {
        setLoading(false);
      }
    }, [listaPrecios]);
  
    // Manejar diferentes estados
    if (loading) {
      return (
        <Box p={4} textAlign="center">
          <Typography variant="body1">Cargando precios...</Typography>
        </Box>
      );
    }
  
    if (error) {
      return (
        <Box p={4} textAlign="center">
          <Typography variant="h6" color="error">
            ⚠️ {error}
          </Typography>
          <Typography variant="body2" mt={2}>
            Verifique la configuración de utilidades y vuelva a intentar
          </Typography>
        </Box>
      );
    }
  
    if (!listaPrecios || listaPrecios.length === 0) {
      return (
        <Box p={4} textAlign="center">
          <Typography variant="h6" color="textSecondary">
            No hay precios configurados para esta región
          </Typography>
        </Box>
      );
    }
  
    // 1. Validación segura del array
    const regionData = (Array.isArray(listaPrecios) ? listaPrecios : [])
    .find(r => 
        r.CatRegion?.IdCatRegion === regionActiva?.idRegion
    ) || { lPaqueteMayoristaRegionPrecios: [] };

    // 2. Obtener la utilidad de la región ya filtrada
    const utilidadObj = regionData.CatUtilidad || {};

    // 3. Procesar circuitos de la región activa
    const circuitosConPrecios = regionData.lPaqueteMayoristaRegionPrecios
    ?.map(circuito => {
        const preciosFiltrados = circuito.lPaqueteMayoristaPrecios
        ?.filter(precio => {
            const regionVuelo = precio.VueloProveedor?.CatRegion?.IdCatRegion;
            return (
            !precio.VueloProveedor || 
            regionVuelo === regionActiva?.idRegion
            );
        }) || [];

        return { ...circuito, preciosFiltrados };
    })
    ?.filter(circuito => circuito.preciosFiltrados?.length > 0) || [];
  
    const renderDetallesVuelo = (vuelo) => {
      if (!vuelo) return (
        <Box p={2} bgcolor="#f5f5f5" borderRadius={4}>
          <Typography variant="body2">
            Servicio Aéreo: No aplica
          </Typography>
        </Box>
      );
  
      return (
        <>
        <Box>
          <Box display="flex" alignItems="center" mb={1}>
            <Typography variant="subtitle1">
              <strong>
                {vuelo.EsRedondo ? '🔄 Vuelo Redondo' : '➡️ Vuelo Sencillo'}
              </strong>
            </Typography>
            <Chip 
              label={vuelo.Proveedor.Nombre}
              size="small" 
              style={{ marginLeft: 8, backgroundColor: '#e3f2fd' }}
            />
          </Box>
  
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Box p={2} bgcolor="#f8f9fa" borderRadius={4}>
                <Typography variant="body2">
                  <strong>Salida:</strong> {formatFechaHora(vuelo.FechaSalida)}
                </Typography>
                <Box mt={1}>
                  <Chip 
                    label={`${vuelo.Origen.CodigoIATA} - ${vuelo.Origen.Descripcion}`}
                    size="small"
                    color="secondary"
                  />
                </Box>
              </Box>
            </Grid>
  
            <Grid item xs={12} md={6}>
              <Box p={2} bgcolor="#f8f9fa" borderRadius={4}>
                <Typography variant="body2">
                  <strong>Llegada:</strong> {formatFechaHora(vuelo.FechaLlegada)}
                </Typography>
                <Box mt={1}>
                  <Chip 
                    label={`${vuelo.Destino.CodigoIATA} - ${vuelo.Destino.Descripcion}`}
                    size="small"
                    color="secondary"
                  />
                </Box>
              </Box>
            </Grid>
          </Grid>
  
          {vuelo.EsRedondo && vuelo.VueloRedondo?.IdVueloRedondo > 0 && (
            <Box mt={2}>
              <Box mt={2}>
                <Typography variant="subtitle2">Vuelto de Regreso:</Typography>
                <Grid container spacing={2} mt={1}>
                  <Grid item xs={12} md={6}>
                    <Box p={2} bgcolor="#fff8e1" borderRadius={4}>
                      <Typography variant="body2">
                        <strong>Salida:</strong> {formatFechaHora(vuelo.VueloRedondo.FechaSalida)}
                      </Typography>
                      <Chip 
                        label={`${vuelo.VueloRedondo.Origen.CodigoIATA} - ${vuelo.VueloRedondo.Origen.Descripcion}`}
                        size="small"
                        color="secondary"
                        style={{ marginTop: 8 }}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Box p={2} bgcolor="#fff8e1" borderRadius={4}>
                      <Typography variant="body2">
                        <strong>Llegada:</strong> {formatFechaHora(vuelo.VueloRedondo.FechaLlegada)}
                      </Typography>
                      <Chip 
                        label={`${vuelo.VueloRedondo.Destino.CodigoIATA} - ${vuelo.VueloRedondo.Destino.Descripcion}`}
                        size="small"
                         color="secondary"
                        style={{ marginTop: 8 }}
                      />
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Box>
          )}
        </Box>
        <Divider style={{ marginTop: 16, marginBottom: 16 }} />
        </>
      );
    };
  
    if (circuitosConPrecios.length === 0) {
      return (
        <Box p={4} textAlign="center">
          <Typography variant="h6" color="textSecondary">
            No hay precios configurados para {regionActiva?.nombreRegion}
          </Typography>
        </Box>
      );
    }
  
    return (
      <Box mt={3}>
        {circuitosConPrecios.map((circuito, index) => (
          <Paper key={`circuito-${index}`} elevation={2} style={{ marginBottom: 24 }}>
            {/* Encabezado del Circuito */}
            <Box p={2} bgcolor="primary.light" color="primary.contrastText" style={{ borderRadius: 4 }}>
              <Typography variant="h6">
                {circuito?.PaqueteCircuito?.ClaveCircuito?.trim()}
              </Typography>
              <Box mt={1} display="flex" gap={1} flexWrap="wrap">
                <Chip
                  label={`${circuito?.PaqueteCircuito?.Dias || 'N/D'} días / ${circuito?.PaqueteCircuito?.Noches || 'N/D'} noches`}
                  size="small"
                  variant="outlined"
                  color="dark"
                  style={{ marginRight: 8 }}
                />

                <Chip
                  label={`Disponibilidad: ${circuito?.PaqueteCircuito?.Disponibilidad || 'N/D'}`}
                  size="small"
                  variant="outlined"
                  color="dark"
                  style={{ marginRight: 8 }}
                />

                <Chip
                  label={`${
                    circuito?.PaqueteCircuito?.FechaInicio 
                      ? new Date(circuito.PaqueteCircuito.FechaInicio).toLocaleDateString() 
                      : 'Sin fecha'
                  } - ${
                    circuito?.PaqueteCircuito?.FechaFin 
                      ? new Date(circuito.PaqueteCircuito.FechaFin).toLocaleDateString() 
                      : 'Sin fecha'
                  }`}
                  size="small"
                  variant="outlined"
                  color="dark"
                  style={{ marginRight: 8 }}
                />
              </Box>
            </Box>
  
            {/* Lista de Precios */}
            {circuito?.preciosFiltrados?.map((precio, pIndex) => {
                const vuelo = precio?.VueloProveedor;
                const tieneVuelo = vuelo?.IdVueloProveedor > 0;
                
                return (
                    <Box key={`precio-${pIndex}`} p={2}>
                        {renderDetallesVuelo(precio.VueloProveedor)}
        
                        {/* Tabla de Desglose de Precios */}
                        <TableContainer>
                        <Table size="small">
                            <TableBody>
                            <TableRow>
                                <TableCell><strong>Costos Base</strong></TableCell>
                                <TableCell align="right"></TableCell>
                            </TableRow>
                            
                            <TableRow>
                                <TableCell style={{ paddingLeft: 32 }}>Servicio Terrestre</TableCell>
                                <TableCell align="right">{formatDinero(precio.MontoNetoTerrestre)}</TableCell>
                            </TableRow>
                                        
                            <TableRow>
                                <TableCell style={{ paddingLeft: 32 }}>Servicio Aéreo</TableCell>
                                <TableCell align="right">{tieneVuelo ? formatDinero(vuelo?.PrecioNeto) : "No aplica"}</TableCell>
                            </TableRow>
                
                            <TableRow style={{ backgroundColor: '#f5f5f5' }}>
                                <TableCell><strong>Subtotal Neto</strong></TableCell>
                                <TableCell align="right">
                                <strong>{formatDinero(precio.PrecioNeto)}</strong>
                                </TableCell>
                            </TableRow>

                            <TableRow>
                                <TableCell><strong>Ajustes al Precio</strong></TableCell>
                                <TableCell align="right"></TableCell>
                            </TableRow>
                            
                            <TableRow>
                                <TableCell style={{ paddingLeft: 32 }}>Utilidad (+{utilidadObj?.Porcentaje || 0}%)</TableCell>
                                <TableCell align="right" style={{ color: '#2e7d32' }}>
                                +{formatDinero(precio.MontoUtilidad)}
                                </TableCell>
                            </TableRow>
                            
                            <TableRow>
                                <TableCell style={{ paddingLeft: 32 }}>Ajustes Comerciales (+{precio.PorcentajeAumento}%)</TableCell>
                                <TableCell align="right" style={{ color: '#2e7d32' }}>
                                +{formatDinero(precio.MontoDescuento)}
                                </TableCell>
                            </TableRow>

                            <TableRow style={{ backgroundColor: '#fff3e0' }}>
                                <TableCell><strong>Precio de Venta Bruto</strong></TableCell>
                                <TableCell align="right">
                                <strong>{formatDinero(precio.MontoAumento)}</strong>
                                </TableCell>
                            </TableRow>

                            <TableRow>
                                <TableCell><strong>Descuentos Aplicados</strong></TableCell>
                                <TableCell align="right"></TableCell>
                            </TableRow>
                            
                            <TableRow>
                                <TableCell style={{ paddingLeft: 32 }}>Promociones y Descuentos</TableCell>
                                <TableCell align="right" style={{ color: '#d32f2f' }}>
                                -{formatDinero(precio.MontoDescuento)}
                                </TableCell>
                            </TableRow>

                            <TableRow style={{ backgroundColor: '#e8f5e9' }}>
                                <TableCell><strong>Precio Total al Público</strong></TableCell>
                                <TableCell align="right">
                                <strong style={{ color: '#2e7d32', fontSize: '1.1rem' }}>
                                    {formatDinero(precio.PrecioTotal)} 
                                </strong>
                                </TableCell>
                            </TableRow>
                            </TableBody>
                        </Table>
                        </TableContainer>
                    </Box>
                )
            })}
          </Paper>
        ))}
      </Box>
    );
  };
  
  export default TablaPreciosAPI;